module.exports = new __parcel__URL__("legacy-of-kain-soul-reaver.afcab6c1.jpg").toString();